import { motion, useReducedMotion } from "framer-motion";

interface Line {
  text: string;
  className?: string;
}

export default function KineticHeading({
  lines,
  className = "",
  delay = 0,
  as: Tag = "h1",
}: {
  lines: Line[];
  className?: string;
  delay?: number;
  as?: "h1" | "h2" | "p" | "div";
}) {
  const reduce = useReducedMotion();
  const MotionTag = motion[Tag] as any;
  return (
    <MotionTag className={className} initial={reduce ? false : "hidden"} animate="visible">
      {lines.map((line, i) => (
        <span key={i} className="-mb-[0.1em] block overflow-hidden pb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${line.className || ""}`}
            initial={reduce ? false : { y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.15, delay: delay + i * 0.15, ease: [0.16, 1, 0.3, 1] }}
          >
            {line.text}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}
